export const kintaiTypes = [
  { id: "AM", name: "午前半休" },
  { id: "PM", name: "午後半休" },
  { id: "FULL", name: "全休" },
  { id: "DAI", name: "代休" },
  { id: "DAIH", name: "半代休" },
  { id: "WH", name: "休日勤務" }, // work on holiday
  { id: "WHH", name: "休日半勤" }, // work on holiday
]
